<template>
  <div class="home">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <h2>{{ welcomeMsg }} {{ user ? user.nombre : "" }}.</h2>
          </v-card-title>
          <v-card-subtitle>
            <span class="font-weight-bold red--text mr-1">¿Cómo ingresar? ➡️ </span>
            <span class="font-weight-bold">{{ novedades[0].text }}</span>
          </v-card-subtitle>
          <v-card-text>
            <v-divider></v-divider>
            <Clock />
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="!user" color="success" to="/login"
              >Iniciar Sesión</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="7">
        <v-card flat>
          <v-card-title>Laundry System {{ currentVersion }}</v-card-title>
          <v-card-text>
            <p>Muchas gracias por el entusiasmo y por probar Laundry System.</p>
            <p>
              🛑🚧Recuerda que esta es una versión BETA por lo que todavía hay algunas
                funcionalidades que no están disponibles o bien podrías encontrar algunos errores)🚧🛑
            </p>
            <p>
              Por favor ayúdanos reportando cualquier error o comportamiento
              inesperado para poder arreglarlo 🔧💻🔨.
            </p>
            <p>
              También eres bienvenido(a) para solicitar más información o un demo guiado en caso
              que estés interesada(o) en adquirir la aplicación ✉️.
            </p>
            <p>
              <a
                class="span-link cyan--text text--lighten-2"
                href="www.youtube.com/channel/UCuoep5NiPkhMcMQiZA88ypQ"
                >Visita nuestros tutoriales en YouTube</a>
              para mostrarte como realizar las acciones que necesitas y a
              descubrir otras capacidades de la app! 🚀
            </p>
            <p>
              <a
                class="span-link cyan--text text--lighten-2"
                href="https://israapps-studio.com/laundry-system/about/"
                >Lee más acerca de Laundry System</a>
            </p>
            <p>
              También ofrecemos servicios de desarrollo y diseño de software y websites
              <a
                class="span-link cyan--text text--lighten-2"
                href="https://israapps-studio.com/"
                >
                Visita nuestro sitio de desarrollo de software para ver 
                  o contratar otros servicios que ofrecemos.
              </a>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="5">
        <v-card max-width="400" color="yellow">
          <v-card-title>
            <v-icon large left color="red"> mdi-pin </v-icon>
            Nota Importante:
          </v-card-title>
          <v-card-subtitle>{{ currentVersion }}</v-card-subtitle>
          <v-card-text>
            <p v-for="(novedad, index) in novedades" :key="index">
              <span :class="novedad.bold ? 'font-weight-bold':''">
                {{ index + 1 }} - {{ novedad.text }}
              </span>
            </p>
            <p>Para más información o para adquirir el software</p>
            <p>
              Contacto:
              <a href="mailto:laundry-system@israapps-studio.com"
                >laundry-system@israapps-studio.com</a
              >
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Clock from "../components/Clock";

// const { openExternalURL } = api.services.httpService;

export default {
  name: "home",
  components: {
    Clock,
  },
  data() {
    return {
      currentVersion: "DEMO V.1.4.0.BETA",
      novedades: [
        {
          text:"Ingresa usando el usuario: admin y contraseña: admin123",
          bold: true,
        },
        { 
          text: `Recuerda que este es sólo un demo y aunque puedes explorar todas las funcionalidades, no podrás guardar tu progreso
          para futuras sesiones, es decir si refrescas la página, cierras el explorador o apagas tu pc, los datos 
          que hayas ingresado y con los que hayas estado trabajando ya no estarán disponibles la vez siguiente ya que este demo
          no cuenta con una base de datos`
        },
        {
          text: `También toma en cuenta que funciones como el respaldo y restablecimiento de bases de datos o impresión de tickets, 
          entre otras cosas tampoco se encuentran disponibles.`
        }
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    welcomeMsg() {
      const msg =
        this.user && this.user.genero
          ? this.user.genero === "h"
            ? "Bienvenido"
            : "Bienvenida"
          : "Bienvenido(a)";
      return msg;
    },
  },
  methods: {
    openExternalLink(baseDomain, url) {
      console.log(baseDomain, url);
      // openExternalURL(baseDomain, url);
    },
  },
};
</script>

<style>
.span-link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
